import { useState } from 'react';
import cx from 'clsx';

import type { EstimateProductPayment } from '~/api/model';
import { IS_BIG_SALE } from '~/domains/plusMembership/constants';

import {
  ChevronDownOutlineIcon24x24,
  MembershipEventIcon,
  RedCoupon16x16Icon,
} from '~/assets/icons';

type Props = {
  data: EstimateProductPayment;
};

export function TotalAmountDetail({ data }: Props) {
  const {
    discountCoupon,
    discountMembershipDiscount,
    totalPrice,
    estimatePrice,
    discountPrice,
    totalQuantity,
    discountMembershipOption,
  } = data;

  const [opened, setOpened] = useState<boolean>(false);

  const isDiscounted =
    Boolean(discountCoupon) ||
    Boolean(discountMembershipDiscount) ||
    Boolean(discountMembershipOption);

  return (
    <div>
      <div className="flex min-h-[42px] flex-col justify-end">
        <div className="flex items-center justify-between text-description typo-caption100-regular">
          <p>상품 금액</p>
          <div>{estimatePrice.toLocaleString()}원</div>
        </div>
        <div className="mt-2 flex items-center justify-between text-description typo-caption100-regular">
          <div className="flex items-center gap-6">
            <p>할인 금액</p>
            {discountMembershipDiscount?.discountType === 'MEMBERSHIP_EVENT' &&
              (IS_BIG_SALE ? (
                <div className="flex items-center gap-4 rounded-lg bg-bigSale-background px-8 py-2 text-bigSale-text typo-footnote300-semibold">
                  <RedCoupon16x16Icon />
                  빅세일 할인 적용
                </div>
              ) : (
                <div className="flex items-center gap-[3px] rounded-md px-8 py-2 text-inverse typo-footnote300-semibold bg-plusmembership-event-badge">
                  <MembershipEventIcon />
                  중복할인 적용
                </div>
              ))}
            {discountMembershipOption?.discountType ===
              'MEMBERSHIP_OPTION_LUCKY_BONUS_PACK' && (
              <div className="flex items-center gap-[3px] rounded-md bg-bonuspackGreen-background px-8 py-2 text-inverse typo-footnote300-semibold">
                행운 보너스팩 적용
              </div>
            )}
          </div>
          <div>-{(discountPrice || 0).toLocaleString()}원</div>
        </div>
      </div>
      <button
        className={cx(
          'mt-12 flex w-full items-center justify-between text-normal',
          isDiscounted && '!text-normal',
        )}
        type="button"
        onClick={() => setOpened((prev) => !prev)}
      >
        <span className="typo-paragraph100-semibold">
          {totalQuantity}개 상품 금액
        </span>
        <div className="flex items-center gap-4">
          <span className="typo-paragraph100-semibold">총</span>
          <span className="break-keep typo-heading100">
            {totalPrice.toLocaleString()}원
          </span>
          {isDiscounted && (
            <ChevronDownOutlineIcon24x24
              className={cx(opened && 'rotate-180')}
            />
          )}
        </div>
      </button>
      {opened && (
        <>
          {discountCoupon && (
            <div className="mt-4 flex items-center justify-between gap-4 text-hint typo-caption100-regular">
              <p className="truncate">{discountCoupon.discountDescription}</p>
              <p>{discountCoupon.calcDiscountAmount.toLocaleString()}원</p>
            </div>
          )}
          {discountMembershipDiscount && (
            <div className="mt-4 flex items-center justify-between gap-4 text-hint typo-caption100-regular">
              <p>멤버십 할인</p>
              <p>{discountMembershipDiscount.discountDescription}</p>
            </div>
          )}
          {discountMembershipOption && (
            <div className="mt-4 flex items-center justify-between gap-4 text-hint typo-caption100-regular">
              <p className="truncate">
                {discountMembershipOption.discountDescription}
              </p>
              <p>
                {discountMembershipOption.calcDiscountAmount.toLocaleString()}원
              </p>
            </div>
          )}
        </>
      )}
    </div>
  );
}
